import { EXTENSION } from '@packages/files/extensions';

export enum MIME_TYPE {
    css = 'text/css',
    csv = 'text/csv',
    html = 'text/html',
    javascript = 'application/javascript',
    pdf = 'application/pdf',
    png = 'image/png',
    jpg = 'image/jpg',
    jpeg = 'image/jpeg',
    psd = 'image/vnd.adobe.photoshop',
}

export const EXTENSION_MIME_MAP: Record<MIME_TYPE, EXTENSION> = {
    [MIME_TYPE.css]: EXTENSION.CSS,
    [MIME_TYPE.csv]: EXTENSION.CSV,
    [MIME_TYPE.html]: EXTENSION.HTML,
    [MIME_TYPE.javascript]: EXTENSION.JAVASCRIPT,
    [MIME_TYPE.pdf]: EXTENSION.PDF,
    [MIME_TYPE.png]: EXTENSION.PNG,
    [MIME_TYPE.jpg]: EXTENSION.JPG,
    [MIME_TYPE.jpeg]: EXTENSION.JPEG,
    [MIME_TYPE.psd]: EXTENSION.PSD,
};

export function extensionByMimeType(mimeType: MIME_TYPE) {
    return EXTENSION_MIME_MAP[mimeType];
}
